<script>
import form from '@/mixins/form';
import normalizeNumbers from '@/utils/normalizeNumbers';

export default {
  name: 'AdsNewsletterModal',
  mixins: [form],
  data() {
    return {
      loading: false,
      subscriberData: {
        email: '',
        name: '',
        title: '',
        phone: '',
      },
    };
  },
  computed: {
    rules() {
      return {
        email: { required: true, message: this.$t('VALIDATION_REQUIRED_ERR') },
        name: { required: true, message: this.$t('VALIDATION_REQUIRED_ERR') },
        title: { required: true, message: this.$t('VALIDATION_REQUIRED_ERR') },
        phone: { required: true, message: this.$t('VALIDATION_REQUIRED_ERR') },
      };
    },
  },
  methods: {
    async subscribeUser() {
      try {
        if (!this.isValid('form')) {
          return;
        }

        this.loading = true;
        await this.$http.post(
          '/api/adbazaar/sales-contact-info/',
          normalizeNumbers(this.subscriberData),
        );
        this.$modal.close();
        this.$message.success(this.$t('ADS_NEWSLETTER_MODAL.SUBSCRIBED'));
      } catch (error) {
        this.$message.error(error.body?.message || error.message);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<template>
  <ElForm
    ref="form"
    class="ads-newsletter-modal"
    :model="subscriberData"
    :rules="rules"
    @submit.native.prevent="subscribeUser"
  >
    <p>{{ $t('ADS_NEWSLETTER_MODAL.DESCRIPTION') }}</p>

    <ElFormItem
      :label="$t('ADS_NEWSLETTER_MODAL.NAME')"
      class="ads-newsletter-modal__input"
      prop="name"
    >
      <ElInput v-model="subscriberData.name" required />
    </ElFormItem>

    <ElFormItem
      :label="$t('ADS_NEWSLETTER_MODAL.PHONE')"
      class="ads-newsletter-modal__input"
      prop="phone"
    >
      <ElInput v-model="subscriberData.phone" required />
    </ElFormItem>

    <ElFormItem
      :label="$t('ADS_NEWSLETTER_MODAL.ROLE')"
      class="ads-newsletter-modal__input"
      prop="title"
    >
      <ElInput v-model="subscriberData.title" required />
    </ElFormItem>

    <ElFormItem
      :label="$t('ADS_NEWSLETTER_MODAL.EMAIL')"
      class="ads-newsletter-modal__input"
      prop="email"
    >
      <ElInput v-model="subscriberData.email" type="email" required />
    </ElFormItem>

    <div class="ads-newsletter-modal__actions">
      <div>
        <ElButton
          type="text"
          size="medium"
          :plain="true"
          @click="$modal.close()"
        >
          {{ $t('CANCEL') }}
        </ElButton>
        <ElButton
          type="primary"
          native-type="submit"
          size="medium"
          :loading="loading"
        >
          {{ $t('ADS_NEWSLETTER_MODAL.SUBSCRIBE') }}
        </ElButton>
      </div>
    </div>
  </ElForm>
</template>

<style lang="scss">
.ads-newsletter-modal {
  &__input + &__input {
    margin-top: 1rem;
  }

  &__actions {
    display: flex;
    justify-content: flex-end;
    margin-top: 2rem;
  }
}
</style>
